<template lang="pug">
    .form-entry-tabs(v-if="enabledExtensions.includes('forms')")
        //- No bar when Form entries is the only hub surface: a single tab is
        //- just the page title repeated.
        tabs(v-if="tabs.length" :items="tabs" :active-tab="activeTab" @click="activateTab")
        slot
    .full-height-error(v-else)
        Error(:message="null" :code="403")
</template>

<i18n>
{
    "de": {
        "Form entries": "Formulareinträge",
        "Conversations": "Konversationen"
    }
}
</i18n>

<script>
import Tabs from '@/components/Tabs';
import Error from '@/components/Error';
import { useSetupStore } from '@/stores';
import { messageHubTabs, activeMessageHubTab } from '@/extensions/communication/messageHubTabs';

export default {
    name: 'FormEntryManagerTabs',
    components: {
        Tabs,
        Error
    },
    computed: {
        // Form entries is one surface of the "Nachrichten" hub. The hub decides
        // whether there is a tab bar at all (it needs more than one surface),
        // so never hard-code a tab list here — that is how this page ended up
        // showing a lone "Formulareinträge" tab while Tickets sat next to it in
        // the menu.
        tabs() {
            return messageHubTabs(this);
        },
        activeTab() {
            return activeMessageHubTab(this.$route.path);
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        }
    },
    methods: {
        activateTab(item) {
            return useSetupStore().activateTab(item)
        }
    }
};
</script>
